import React from "react";

import classNames from "classnames";

export const HelperText = ({
  children,
  className,
}: {
  className?: string;
  children?: React.ReactNode;
}) =>
  children ? (
    <div className={classNames(className, `text-xs italic text-primary-400`)}>
      {children}
    </div>
  ) : null;

export const ErrorText = ({
  inError,
  children,
}: {
  inError: boolean;
  children: React.ReactNode;
}) => (inError ? <p className="text-red-500">{children}</p> : null);

export const Label = ({
  children,
  htmlFor,
  disabled,
}: {
  children?: React.ReactNode;
  htmlFor?: string;
  disabled?: boolean;
}) =>
  children ? (
    <label
      className={classNames("block text-xs font-bold", {
        "text-neutral-500": disabled,
        "text-neutral-600": !disabled,
      })}
      htmlFor={htmlFor}
    >
      {children}
    </label>
  ) : null;
